var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.process.length > 0)?_c('div',{staticClass:"process"},_vm._l((_vm.process),function(item,i){return _c('div',{key:i,staticClass:"gp"},[_c('div',{staticClass:"box"},[_c('img',{attrs:{"src":item.image_url}})]),_c('p',[_vm._v(_vm._s(item.image_name))])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }